var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMyDashboard1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 81,
    height: 70,
    viewBox: "0 0 81 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.7792 40.5167H37.4458V20.0292H33.7792V40.5167ZM24.9333 40.5167H28.6V27.5458H24.9333V40.5167ZM75.4417 0H5.5C2.475 0 0 2.475 0 5.5V53.0292C0 56.0542 2.475 58.5292 5.5 58.5292H33V65.6333H19.4333V69.3H61.5083V65.6333H47.9417V58.5292H75.4417C78.4667 58.5292 80.9417 56.0542 80.9417 53.0292V5.5C80.9417 2.475 78.4667 0 75.4417 0ZM44.275 65.6333H36.6667V58.5292H44.275V65.6333ZM77.275 53.0292C77.275 54.0375 76.45 54.8625 75.4417 54.8625H5.5C4.49167 54.8625 3.66667 54.0375 3.66667 53.0292V50.6H71.775V46.9333H3.66667V5.5C3.66667 4.49167 4.49167 3.66667 5.5 3.66667H75.4417C76.45 3.66667 77.275 4.49167 77.275 5.5V53.0292ZM43.0375 40.5167H46.7042V10.45H43.0375V40.5167ZM52.3417 40.5167H56.0083V20.0292H52.3417V40.5167Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMyDashboard1);
export default __webpack_public_path__ + "static/media/my-dashboard 1.3d70bb56902d13403b7d724a25e8f178.svg";
export { ForwardRef as ReactComponent };